import { t } from 'i18next';
import React from 'react';
import styled from 'styled-components';
import Typography from '../typography/Typography';

interface IViewIcon {
    style?: any;
    onClick?: any;
    size?: number;
}

const IconContainer = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const Icon = styled.div`
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    margin-bottom: 4px;
    height: 38px;
    width: 38px;

    transition: all 0.5s;

    &:hover {
        background-color: ${props => props.theme.colors.inputBackground};
    }

    &:active {
        background-color: ${props => props.theme.colors.border};
    }
`;

const ViewIcon: React.FC<IViewIcon> = ({style, onClick, size=24}: IViewIcon) => {

    return (
        <IconContainer style={style} onClick={onClick}>
            <Icon>
                <svg width={size} height={size} viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.83497 10.2561C1.38835 9.47815 1.38834 8.52198 1.83497 7.74407C4.18496 3.65097 7.94378 1 12.1798 1C16.4158 1 20.1746 3.65094 22.5246 7.74398C22.9712 8.52189 22.9712 9.47806 22.5246 10.256C20.1746 14.3491 16.4158 17 12.1798 17C7.94377 17 4.18497 14.3491 1.83497 10.2561Z" stroke="#14142B" strokeWidth="2"/>
                    <circle cx="12.1797" cy="9" r="3" stroke="#14142B" strokeWidth="2"/>
                </svg>
            </Icon>
            <Typography color="title" type="paragraphXS">{t('view')}</Typography>
        </IconContainer>
    )
}

export default ViewIcon;